<template>
  <div class="py-2 px-md-0 py-md-4">
    <banner-component :img-name="bannerImgSid" title="" class="banner-component">
      <b-row class="w-100" no-gutters>
        <b-col
          v-for="(item, index) in countsData"
          :key="index"
          cols="12"
          :md="countsData.length === 2 ? 6 : 4"
          class="pb-4 px-1"
          :class="[{ 'mb-3': !isHide }]"
        >
          <router-link :to="item.link" class="welcome-count__number d-block display-1 mb-0 text-center timer text-white">
            <ICountUp :delay="1000" :endVal="item.count" :options="options" />
          </router-link>
          <router-link :to="item.link" class="welcome-count__text d-block fs-4 mb-0 text-center text-white">
            <span class="fw-bolder" v-html="item.title"></span>
          </router-link>
        </b-col>
        <!-- isAI: AI search input -->
        <b-col v-if="isHide && isEnabledAi" v-show="searchMode === 'ki'" cols="12" class="px-1 mb-1 mb-sm-0" xl>
          <div class="position-relative">
            <b-form-input
              class="welcome-search-input"
              style="border-radius: 5px; height: 46px;"
              v-model="aiSearchText"
              :placeholder="translations[15928]"
              @keyup.enter="searchAi"
            ></b-form-input>
          </div>
        </b-col>
        <b-col v-if="isHide" v-show="!isEnabledAi || searchMode !== 'ki'" cols="12" class="px-1 mb-1 mb-sm-0" sm="6" xl>
          <!--          <select-profession :border="true" :lg="true" v-model="selectProfession" />-->
          <div class="position-relative" v-show="!fulltext">
            <select-profession-update v-model="selectProfession" :fixed="true" />
          </div>
          <div class="position-relative" v-show="fulltext">
            <b-input-group>
              <b-form-input
                class="welcome-search-input"
                style="border-radius: 5px; height: 46px;"
                @keyup="clearProfession"
                v-model="searchText"
                :placeholder="translations[10431]"
              ></b-form-input>
              <b-input-group-append v-show="searchText.length">
                <b-button variant="primary" @click.prevent="searchText = ''">
                  <b-icon icon="x" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col>
        <b-col v-if="isHide" v-show="!isEnabledAi || searchMode !== 'ki'" cols="12" class="px-1" sm="6" xl>
          <select-location
            :placeholder="isHide ? searchPlaceholder : `${translations[13589]}...`"
            :border="true"
            :lg="true"
            v-model="selectLocation"
          />
        </b-col>
        <!-- isAI: search mode toggle -->
        <b-col v-if="isEnabledAi" cols="12" class="px-1 mb-1 order-2 order-xl-3">
          <ai-custom-checkbox :value="searchMode" @input="onSearchModeInput" />
        </b-col>
        <b-col v-if="isHide" cols="12" class="px-0 mt-1 mt-xl-0 order-3 order-xl-2" xl="auto">
          <b-row no-gutters>
            <!-- isAI: AI search button -->
            <b-col class="px-1" v-if="isEnabledAi && searchMode === 'ki'">
              <b-button
                variant="primary"
                size="lg"
                class="w-100 custom-btn d-flex align-items-center justify-content-center"
                :disabled="aiSearchLoading"
                @click="searchAi"
              >
                <b-spinner v-if="aiSearchLoading" small class="mr-2"></b-spinner>
                {{ translations[13938] }}
              </b-button>
            </b-col>
            <b-col class="px-1" v-else>
              <b-button variant="primary" size="lg" class="w-100 custom-btn" @click="search">{{ translations[13938] }}</b-button>
            </b-col>
            <b-col class="px-1">
              <b-button @click="searchFilter" variant="primary" size="lg" class="w-100 whitespace-nowrap custom-btn" v-b-toggle.jobs-filter>
                <b-icon icon="sliders" class="d-inline-block d-sm-inline-block d-lg-none"></b-icon>
                <span class="ml-1 d-none d-sm-inline-block">{{ translations[13939] }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </banner-component>
    <b-row>
      <b-col>
        <div class="welcome-intro" :class="{ 'welcome-intro--accent': sid === 'amseu' }">
          <h2 class="welcome-intro__title" v-html="contentTitle"></h2>
          <p class="welcome-intro__desc m-0 fs-4 mb-4" v-html="contentDescription" />
        </div>
      </b-col>
    </b-row>

    <jobs-information-box :is-welcome="true" />
    <text-information-box />
    <jobs-filter :is-welcome="true" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import BannerComponent from '@/components/BannerComponent.vue';
import ProfessionsComponent from '@/components/Home/ProfessionsComponent.vue';
import JobsFilter from '@/components/FilterSidebar/JobsFilter.vue';
import NotAuthModal from '@/components/Core/NotAuthModal.vue';
import JobComponent from '@/components/Home/JobComponent.vue';
import JobComponentCluster from '@/components/Home/JobComponentCluster.vue';
import JobsInformationBox from '@/components/Home/JobsInformationBox.vue';
import TextInformationBox from '@/components/Welcome/TextInformationBox.vue';
import SelectProfession from '@/components/Widget/SelectProfession.vue';
import SelectLocation from '@/components/Widget/SelectLocation.vue';
import { ProfessionModule } from '@/store/modules/profession';
import { AppModule, SettingsCounters } from '@/store/modules/app';
import ICountUp from 'vue-countup-v2';
import { JobType } from '@/types/ProfessionType';
import { mixins } from 'vue-class-component';
import LocaleStringMixin from '@/mixins/LocaleStringMixin';
import AiJobSearchMixin from '@/mixins/AiJobSearchMixin';
import SelectProfessionUpdate from '@/components/Widget/SelectProfessionUpdate.vue';
import AiCustomCheckbox from '@/components/Core/Ai/AiCustomCheckbox.vue';
import { ThemesModule } from '@/store/modules/themes';

@Component({
  metaInfo(this: any): any {
    return {
      title: this.pageTitles[this.lang] || this.pageTitles.de,
      meta: [{ name: 'description', content: this.pageDescriptions[this.lang] || this.pageDescriptions.de }],
    };
  },
  components: {
    BannerComponent,
    JobsInformationBox,
    ProfessionsComponent,
    JobsFilter,
    NotAuthModal,
    JobComponent,
    SelectProfession,
    SelectLocation,
    ICountUp,
    TextInformationBox,
    JobComponentCluster,
    SelectProfessionUpdate,
    AiCustomCheckbox,
  },
})
export default class WelcomeView extends mixins(LocaleStringMixin, AiJobSearchMixin) {
  fulltext = false;

  aiSearchText = '';

  aiSearchLoading = false;

  searchMode: 'ki' | 'berufsgruppe' | 'volltext' = 'ki';

  onSearchModeInput(mode: 'ki' | 'berufsgruppe' | 'volltext') {
    this.searchMode = mode;
    this.fulltext = mode === 'volltext';
  }

  clearProfession() {
    this.fulltext = true;
    this.searchMode = 'volltext';
    this.selectProfession = null;
  }

  get isEnabledAi() {
    return Number(AppModule.setting?.enable_ai_jobs_search) === 1;
  }

  get pageTitles() {
    return {
      de: this.title || this.titleSid.de,
      en: this.title || this.titleSid.en,
    };
  }

  pageDescriptions = {
    de: 'Jobs in Österreich suchen & finden ✔ Jobbörse für Österreich ✔ Jobaustausch für Arbeitnehmer & Arbeitgeber ✔ Jetzt informieren & in Österreich arbeiten!',
    en: 'Austria job search ✔ job offers for employers ✔ vacancies in Austria ✔ Search for industries and locations ✔ Find out now and work in Austria!',
  };

  // temp Title
  get titleSid(): { de: string, en: string } {
    if (ThemesModule.sample.title) {
      return ThemesModule.sample.title;
    }
    return {
      de: 'Arbeiten in Österreich – Jobs suchen ✔ | WORK IN AUSTRIA',
      en: 'Working in Austria – find jobs in austria | WORK IN AUSTRIA',
    };
  }

  get bannerImgSid() {
    return 'amseu-slide-v1';
  }

  get title() {
    return AppModule.settingPortal.html_title;
  }

  get contentTitle() {
    return AppModule.settingPortal.content_title;
  }

  get contentDescription() {
    return AppModule.settingPortal.content_description;
  }

  get searchPlaceholder() {
    return AppModule.settingPortal.search_input_jobs_placeholder || `${this.translations[9503]}...`;
  }

  get headerImage() {
    return AppModule.settingPortal.header_image;
  }

  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return AppModule.language;
  }

  get sid() {
    return AppModule.sid;
  }

  get isHide() {
    return !['aba', 'abatest'].includes(this.sid);
  }

  get allCount(): number {
    return Number(AppModule.setting?.all_count || 0);
  }

  get allCountCompany(): number {
    return Number(AppModule.setting?.companies_count || 0);
  }

  get allCountWorkers(): number {
    return Number(AppModule.setting?.applicant_search_tab?.overall_applicants_count || 0);
  }

  get isAlternativeCountTheme() {
    return ['wconat', 't4a'].includes(this.sid);
  }

  get countsData() {
    return [
      {
        count: this.allCountCompany,
        title: this.translations[14670],
        link: '/company',
        order: this.getCounterDataOrder('companies'),
        visibility: this.getCounterDataVisibility('companies'),
      },
      {
        count: this.allCountWorkers,
        title: this.translations[14671],
        link: '/workers',
        order: this.getCounterDataOrder('applicants'),
        visibility: this.getCounterDataVisibility('applicants'),
      },
      {
        count: this.allCount,
        title: this.translations[14672],
        link: '/jobs',
        order: this.getCounterDataOrder('jobs'),
        visibility: this.getCounterDataVisibility('jobs'),
      },
    ]
      .filter((el) => el.visibility)
      .sort((a, b) => a.order - b.order);
  }

  getCounterDataOrder(value: SettingsCounters['name']) {
    return AppModule.settingPortal.counters.findIndex((el) => el.name === value);
  }

  getCounterDataVisibility(value: SettingsCounters['name']) {
    return !!AppModule.settingPortal.counters.find((el) => el.name === value)?.visible;
  }

  options = {
    useEasing: true,
    useGrouping: true,
    separator: AppModule.language === 'en' ? ',' : '.',
    decimal: '.',
    prefix: '',
    suffix: '',
  };

  // search
  get selectProfession() {
    return ProfessionModule.searchJobProfession;
  }

  set selectProfession(value: any) {
    ProfessionModule.SetSearchJobProfession(value);
    ProfessionModule.SetSearchJobProfessionTitle(value);
    ProfessionModule.SetSearch({ obj: 'profession_id', value: value?.map((v: any) => v.id).join(',') || null });
  }

  get selectLocation() {
    return ProfessionModule.searchJobLocation;
  }

  set selectLocation(value: any) {
    ProfessionModule.SetSearchJobLocation(value);
    ProfessionModule.SetSearchJobLocationTitle(value);
    ProfessionModule.SetSearch({ obj: 'location_id', value: value?.id || null });
  }

  searchFilter() {
    ProfessionModule.SetJobType(JobType.search);
  }

  // full-text search
  get searchText() {
    return ProfessionModule.jobSearch.q;
  }

  set searchText(value) {
    ProfessionModule.SetSearch({ obj: 'q', value });
    ProfessionModule.SetSearch({ obj: 'qmode', value: 2 });
  }

  search() {
    // у режимі Volltext зберігаємо введений текст до параметра q (SET_SEARCH_DEFAULT його скидає)
    const volltextQuery = this.searchMode === 'volltext' ? this.searchText : '';
    ProfessionModule.SET_FILTER_DEFAULT();
    ProfessionModule.SET_SEARCH_DEFAULT();
    ProfessionModule.SET_PARAMS_DEFAULT();
    ProfessionModule.SET_TAGS_DEFAULT();
    ProfessionModule.SetProfessionTitle('');
    if (volltextQuery) {
      ProfessionModule.SetSearch({ obj: 'q', value: volltextQuery });
      ProfessionModule.SetSearch({ obj: 'qmode', value: 2 });
      ProfessionModule.SetSearchTags({ tag: 'textTag', value: volltextQuery });
    }
    ProfessionModule.SetJobType(JobType.search);
    AppModule.SetVisibleMap(false);
    AppModule.SetVisibleJobs(true);
    AppModule.SetVisibleClusterJobs(false);
    AppModule.SET_WELCOME(true);
    this.$router.push({ name: 'Jobs', query: { lang: AppModule.language } });
  }

  async searchAi() {
    this.aiSearchLoading = true;
    try {
      await this.applyAiFilters(this.aiSearchText, true);
    } finally {
      this.aiSearchLoading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
// фокус інпутів пошуку в банері — синій ring замість дефолтного (оранжевого) bootstrap-primary
.welcome-search-input:focus {
  border-color: #0054a6 !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 84, 166, 0.25) !important;
}

// banner — Tailwind-шкала з дизайну (число стилюється глобально через .timer.text-white)
.welcome-count {
  &__text {
    font-size: 0.875rem !important; // text-sm

    @media (min-width: 640px) {
      font-size: 1rem !important; // sm:text-base
    }
    @media (min-width: 768px) {
      font-size: 1.125rem !important; // md:text-lg
    }

    .fw-bolder {
      font-weight: 400 !important;
    }
  }
}

.welcome-intro--accent {
  border-left: 4px solid #e4003a;
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;

  .welcome-intro__title {
    color: #004f9f !important;
    font-size: 1.875rem;
    font-weight: 700 !important;
    letter-spacing: -0.02em;
    margin-bottom: 0.75rem;

    @media (min-width: 768px) {
      font-size: 2.25rem;
    }
  }

  .welcome-intro__desc {
    max-width: 48rem;
    color: #333333;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px !important;
    line-height: 1.6;
  }
}
</style>
